module.exports = __webpack_public_path__ + "img/list_Character_sq_14.59c486b9.jpeg";